import { render } from "./promos.vue?vue&type=template&id=619058f8"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__